/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";
import LaunchDarklyContextChangeListener from "./LaunchDarklyContextChangeListener";
import { resolveLaunchDarklyContext } from "./resolveLaunchDarklyContext";
import { useSelector } from "react-redux";
import { makeSelectisguestSignInUser } from "ducks/selectors/authInfo";
import { makeSelectLoggedInUserDetails } from "ducks/selectors/userProfileDetails";
import { getItem, setItem } from "utils/localStorage";
import { get } from "lodash";

// Singleton pattern to ensure asyncWithLDProvider is called only once
let LDProviderPromise = null;

const getLDProviderPromise = launchDarklyOptions => {
  const clientSideID = process.env.REACT_APP_DARKLY_CLIENT_SIDE_ID;

  if (launchDarklyOptions?.enabled && !clientSideID) {
    console.error(
      "launchdarkly_client_side_id not defined, either disable launchdarkly from app config or set the env var 'launchdarkly_client_side_id' with sre help"
    );
    return;
  }
  if (launchDarklyOptions?.enabled && !LDProviderPromise) {
    const { userEmail, userId, isGuestUser } = JSON.parse(
      getItem("authInfoLaunchDarkly")
    );
    const ctx = resolveLaunchDarklyContext({ userEmail, userId, isGuestUser });
    LDProviderPromise = asyncWithLDProvider({
      clientSideID,
      context: ctx,
      options: {
        diagnosticOptOut: true,
        ...launchDarklyOptions
        /* ... */
      }
    });
  }

  return LDProviderPromise;
};

const LaunchDarklyProvider = ({ children, options }) => {
  const [LDProvider, setLDProvider] = useState(null);
  const authInfoLaunchDarkly = {
    userEmail: get(useSelector(makeSelectLoggedInUserDetails()), "email", ""),
    userId: get(
      useSelector(makeSelectLoggedInUserDetails()),
      "external_id",
      ""
    ),
    isGuestUser: useSelector(makeSelectisguestSignInUser())
  };

  useEffect(() => {
    setItem("authInfoLaunchDarkly", JSON.stringify(authInfoLaunchDarkly));
  }, [authInfoLaunchDarkly]);

  useEffect(() => {
    getLDProviderPromise(options);

    // eslint-disable-next-line no-unused-expressions
    LDProviderPromise?.then(provider => {
      if (!LDProvider) {
        setLDProvider(prevVal => {
          if (!prevVal) {
            return provider;
          }
          return prevVal;
        });
      }
    }).catch(() => {
      // Handle error if needed
    });
  }, [LDProvider, options]);

  return LDProvider ? (
    <LDProvider>
      <LaunchDarklyContextChangeListener />
      {children}
    </LDProvider>
  ) : (
    <>{children}</>
  );
};

export default LaunchDarklyProvider;
